import styled from "styled-components"
import { MEDIA_QUERIES } from "@constants"

export const InterviewBuilderContentARTICLE = styled.article`
  background: var(--color--cobalt-100);
  padding: 0 0 var(--spacing--XL);

  .Row {
    align-items: flex-start;

    ${MEDIA_QUERIES.L} {
      align-items: stretch;
    }
  }
`

export const InterviewBuilderContentActionsDIV = styled.div`
  margin: 0 auto var(--spacing--M);

  ${MEDIA_QUERIES.L} {
    position: sticky;
    top: calc(var(--SiteNav--height) + var(--spacing--M));
    max-width: 290px;
    margin-bottom: 0;
  }

  h2,
  .Button {
    margin-bottom: 20px;
  }

  h2 {
    color: var(--color--charcoal-900);
  }

  .Button {
    width: 100%;

    ${MEDIA_QUERIES.M} {
      width: auto;
      margin-right: var(--spacing--XS);
    }

    ${MEDIA_QUERIES.L} {
      width: 100%;
      margin-right: 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
`

export const InterviewBuilderContentDIV = styled.div`
  max-width: 720px;
  margin: 0 auto;

  h3 {
    font-size: var(--font-size--h4);

    &:first-child {
      margin-top: 0;
    }
  }

  h4 {
    font-size: var(--font-size--overline-M);
    line-height: var(--line-height--overline);
    letter-spacing: var(--letter-spacing--overline);
    text-transform: uppercase;
    color: var(--color--charcoal-600);
  }

  h3,
  h4 {
    margin-top: var(--spacing--S);
  }

  p,
  ul {
    font-size: var(--font-size--M);
    line-height: var(--line-height--text);
    color: var(--color--charcoal-900);
    margin: 0 0 var(--spacing--XS);
  }

  ul {
    padding-left: 25px;

    li {
      padding-left: 5px;

      &::marker {
        font-size: 0.75em;
      }
    }
  }

  blockquote {
    padding: 30px;
    background: #e6edff; // somewhere between INDIGO 100 & 200
    border: 1px solid var(--color--cobalt-100);
    border-radius: 4px;

    & *:last-child {
      margin-bottom: 0;
    }
  }
`
